import React from 'react';

const VoteArrow = ({ height = 32, color = '#494949', selected = false }) => {
  const width = height;

  if (selected) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={height} width={width} fill={color}>
        <path
          d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM382.6 254.6c-12.5 12.5-32.75 12.5-45.25 0L288 205.3V384c0 17.69-14.33 32-32 32s-32-14.31-32-32V205.3L174.6 254.6c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l103.1-103.1C241.3 97.4 251.1 96 256 96c4.881 0 14.65 1.391 22.65 9.398l103.1 103.1C395.1 221.9 395.1 242.1 382.6 254.6z"/>
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={height} width={width} fill={color}>
      <path
        d="M273.6 119.7C269 114.8 262.7 112 256 112S242.1 114.8 238.4 119.7l-104 112c-9 9.719-8.438 24.91 1.25 33.94c9.719 9 24.88 8.469 33.94-1.25L232 197.1V368c0 13.25 10.75 24 24 24s24-10.75 24-24V197.1l62.41 67.21c9.062 9.719 24.22 10.25 33.94 1.25c9.688-9.031 10.25-24.22 1.25-33.94L273.6 119.7zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464z"/>
    </svg>
  );
};

export default VoteArrow;
